import { Deserializable } from '../../protocols/deserializable';
import { LookAheadItem } from '../../../views/shared/components/search-with-look-ahead/look-ahead-list/look-ahead-item/protocol/look-ahead-item';
import { EmploymentStatusTypeId } from '../../employers/enum/employment-status-type-id';
import { EmploymentStatusType } from '../../types/dto/employment-status-type';

export class EmployeeUser implements Deserializable, LookAheadItem {
  public id!: number;
  public firstName!: string;
  public middleName!: string;
  public lastName!: string;
  public email!: string;
  public birthdate!: string;
  public socialInsuranceNumber!: string;
  public addressId!: string;
  public genderId!: number;
  public primaryPhoneNumberCountryCode!: string;
  public primaryPhoneNumber!: string;
  public secondaryPhoneNumberCountryCode!: string;
  public secondaryPhoneNumber!: string;
  public lastContributionDate!: string;
  public employmentStatusId!: EmploymentStatusTypeId;
  public employmentStatus!: EmploymentStatusType;

  // Not returned from API
  public fullName!: string;

  onDeserialize(): void {
    this.fullName = `${this?.firstName} ${this?.lastName}`.trim();
  }

  // Look ahead item interface
  lookAheadDisabled(): boolean {
    return false;
  }

  lookAheadDisabledMessage(): string {
    return 'disabled';
  }
}
